import { useCallback, useEffect, useRef, useState } from "react";
import { investingApi } from "../../services/api";

/**
 * The executor's latest reading of the account (GET snapshots/latest/),
 * for the Target and Fund pages: `{loading, snapshot, error, retry}`.
 * `snapshot` is null before the first one (the API's 404) — that isn't an
 * error, it's the empty state. Reloads when `reloadTick` moves; only the
 * newest request lands.
 */
export default function useLatestSnapshot(reloadTick = 0) {
  const [state, setState] = useState({ loading: true, snapshot: null, error: null });
  const [retryTick, setRetryTick] = useState(0);
  const requestRef = useRef(0);

  useEffect(() => {
    const request = ++requestRef.current;
    setState((now) => ({ ...now, loading: true, error: null }));
    investingApi.snapshots.latest().then(
      ({ data }) => {
        if (request !== requestRef.current) return;
        setState({ loading: false, snapshot: data, error: null });
      },
      (err) => {
        if (request !== requestRef.current) return;
        if (err?.response?.status === 404) setState({ loading: false, snapshot: null, error: null });
        else setState({ loading: false, snapshot: null, error: err });
      },
    );
  }, [reloadTick, retryTick]);

  const retry = useCallback(() => setRetryTick((tick) => tick + 1), []);
  return { ...state, retry };
}
